/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModalHeaderTitle/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaModalHeaderTitle({
  children,
  viewPath = "/DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle",
  marginLeft,
  text
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={15}
 weight="medium"
 marginLeft={marginLeft}
 text={text}
/>
{children}
</React.Fragment>)
}